import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { ContentCopy } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { alertActions } from "../store/alertSlice";

const CouponCodeCopy = ({ couponCode, size = "medium" }) => {
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();

  // Handle coupon copy
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(couponCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      
      dispatch(
        alertActions.setAlert({
          title: "Coupon code copied to clipboard!",
          messageType: "success",
        })
      );
    } catch (err) {
      console.error("Failed to copy coupon:", err);
      dispatch(
        alertActions.setAlert({
          title: "Failed to copy coupon code",
          messageType: "error",
        })
      );
    }
  };

  return (
    <CouponCodeContainer size={size}>
      <CouponCode size={size}>{couponCode}</CouponCode>
      <CopyButton
        onClick={handleCopy}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        size={size}
      >
        <ContentCopy fontSize="small" />
        {copied ? "Copied!" : "Copy"}
      </CopyButton>
    </CouponCodeContainer>
  );
};

export default CouponCodeCopy;

const CouponCodeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.size === "small" ? "10px" : "15px"};
`;

const CouponCode = styled.span`
  border: 2px dotted var(--primary-color);
  padding: ${props => {
    if (props.size === "small") return "8px 15px";
    if (props.size === "large") return "15px 25px";
    return "12px 20px";
  }};
  border-radius: 8px;
  font-family: 'Courier New', monospace;
  font-weight: bold;
  font-size: ${props => {
    if (props.size === "small") return "0.9rem";
    if (props.size === "large") return "1.3rem";
    return "1.1rem";
  }};
  color: var(--primary-color);
  flex: 1;
  text-align: center;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: var(--primary-dark-color);
    color: var(--primary-dark-color);
  }
`;

const CopyButton = styled(motion.button)`
  background: var(--primary-color);
  color: white;
  border: none;
  padding: ${props => {
    if (props.size === "small") return "8px 12px";
    if (props.size === "large") return "15px 20px";
    return "12px 16px";
  }};
  border-radius: 8px;
  font-weight: 600;
  font-size: ${props => {
    if (props.size === "small") return "0.8rem";
    if (props.size === "large") return "1rem";
    return "0.9rem";
  }};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
  
  &:hover {
    background: var(--primary-dark-color);
    transform: translateY(-1px);
  }
`; 